"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = watchers;
var _effects = require("redux-saga/effects");
var _sagas = require("../../../astercore/auth/login/redux/sagas");
var api = _interopRequireWildcard(require("../api/api"));
var actions = _interopRequireWildcard(require("./actions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function* getPopularCategoriesAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_POPULAR_CATEGORIES_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getPopularCategories, tokenData);
    yield (0, _effects.put)(actions.GET_POPULAR_CATEGORIES_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_POPULAR_CATEGORIES_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getTopDealsAPI(params) {
  try {
    var _params$data;
    yield (0, _effects.put)(actions.GET_TOP_DEALS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getTopDeals, params === null || params === void 0 || (_params$data = params.data) === null || _params$data === void 0 ? void 0 : _params$data.params, tokenData);
    yield (0, _effects.put)(actions.GET_TOP_DEALS_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_TOP_DEALS_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getEssentialProductsAPI(params) {
  try {
    var _params$data2;
    yield (0, _effects.put)(actions.GET_ESSENTAIL_PRODUCTS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getEssentialProducts, params === null || params === void 0 || (_params$data2 = params.data) === null || _params$data2 === void 0 ? void 0 : _params$data2.params, tokenData);
    yield (0, _effects.put)(actions.GET_ESSENTAIL_PRODUCTS_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_ESSENTAIL_PRODUCTS_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getTrendingProductsAPI(params) {
  try {
    var _params$data3;
    yield (0, _effects.put)(actions.GET_TRENDING_PRODUCTS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getTrendingProducts, params === null || params === void 0 || (_params$data3 = params.data) === null || _params$data3 === void 0 ? void 0 : _params$data3.params, tokenData);
    yield (0, _effects.put)(actions.GET_TRENDING_PRODUCTS_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_TRENDING_PRODUCTS_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getHealthCondtionsAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_HEALTH_CONDITIONS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getHealthConditions, tokenData);
    yield (0, _effects.put)(actions.GET_HEALTH_CONDITIONS_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_HEALTH_CONDITIONS_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getPharmcayBannersAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_PHARMACY_BANNER_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getPharmacyBanner, tokenData);
    yield (0, _effects.put)(actions.GET_PHARMACY_BANNER_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PHARMACY_BANNER_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getLoyaliticspointsAPI(requestParam) {
  const {
    params
  } = requestParam.data;
  try {
    yield (0, _effects.put)(actions.GET_LOYALTICS_POINTS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getLoyaliticspoints, params, tokenData);
    yield (0, _effects.put)(actions.GET_LOYALTICS_POINTS_API.success(mainResponse));
    requestParam.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_LOYALTICS_POINTS_API.failure(err));
    if (requestParam.data && requestParam.data.onFailure) {
      requestParam.data.onFailure(err);
    }
  }
}
function* getPharmacyBannersMiddleAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_PHARMACY_BANNERS_MIDDLE_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getPharmacyBannersMiddle, tokenData);
    yield (0, _effects.put)(actions.GET_PHARMACY_BANNERS_MIDDLE_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PHARMACY_BANNERS_MIDDLE_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getPharmacyBannersBottomAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_PHARMACY_BANNERS_BOTTOM_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getPharmacyBannersBottom, tokenData);
    yield (0, _effects.put)(actions.GET_PHARMACY_BANNERS_BOTTOM_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PHARMACY_BANNERS_BOTTOM_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getPharmacyShopByBrandAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_PHARMACY_SHOP_BY_BRAND_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getPharmacyShopByBrand, tokenData);
    yield (0, _effects.put)(actions.GET_PHARMACY_SHOP_BY_BRAND_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PHARMACY_SHOP_BY_BRAND_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getEpharmacyBannerApi(params) {
  try {
    yield (0, _effects.put)(actions.GET_EPHARMACY_BANNER_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getEpharmacyBanners, params.data.params.bannerId, tokenData);
    yield (0, _effects.put)(actions.GET_EPHARMACY_BANNER_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_EPHARMACY_BANNER_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getPharmacyCategoriesMenu(params) {
  try {
    yield (0, _effects.put)(actions.GET_PHARMACY_CATEGORY_MENU_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getPharmacyCategoriesMenu, tokenData);
    yield (0, _effects.put)(actions.GET_PHARMACY_CATEGORY_MENU_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PHARMACY_CATEGORY_MENU_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getLandingPageData(params) {
  try {
    yield (0, _effects.put)(actions.GET_LANDING_PAGE_DATA_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getLandingPageData, params.data.params.slug, tokenData);
    yield (0, _effects.put)(actions.GET_LANDING_PAGE_DATA_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_LANDING_PAGE_DATA_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getCrossModuleComponentData(params) {
  try {
    yield (0, _effects.put)(actions.GET_CROSS_MODULE_COMPONENT_DATA_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getCrossModuleComponentData, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_CROSS_MODULE_COMPONENT_DATA_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_CROSS_MODULE_COMPONENT_DATA_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* watchers() {
  yield (0, _effects.takeLatest)(actions.GET_POPULAR_CATEGORIES, getPopularCategoriesAPI);
  yield (0, _effects.takeLatest)(actions.GET_TOP_DEALS, getTopDealsAPI);
  yield (0, _effects.takeLatest)(actions.GET_ESSENTAIL_PRODUCTS, getEssentialProductsAPI);
  yield (0, _effects.takeLatest)(actions.GET_TRENDING_PRODUCTS, getTrendingProductsAPI);
  yield (0, _effects.takeLatest)(actions.GET_HEALTH_CONDITIONS, getHealthCondtionsAPI);
  yield (0, _effects.takeLatest)(actions.GET_PHARMACY_BANNER, getPharmcayBannersAPI);
  yield (0, _effects.takeLatest)(actions.GET_LOYALTICS_POINTS, getLoyaliticspointsAPI);
  yield (0, _effects.takeLatest)(actions.GET_PHARMACY_BANNERS_MIDDLE, getPharmacyBannersMiddleAPI);
  yield (0, _effects.takeLatest)(actions.GET_PHARMACY_BANNERS_BOTTOM, getPharmacyBannersBottomAPI);
  yield (0, _effects.takeLatest)(actions.GET_PHARMACY_SHOP_BY_BRAND, getPharmacyShopByBrandAPI);
  yield (0, _effects.takeEvery)(actions.GET_EPHARMACY_BANNER, getEpharmacyBannerApi);
  yield (0, _effects.takeLatest)(actions.GET_PHARMACY_CATEGORY_MENU, getPharmacyCategoriesMenu);
  yield (0, _effects.takeLatest)(actions.GET_LANDING_PAGE_DATA, getLandingPageData);
  yield (0, _effects.takeLatest)(actions.GET_CROSS_MODULE_COMPONENT_DATA, getCrossModuleComponentData);
}